import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.248 10.952L1.08 2.769a.5.5 0 0 1 .625-.724l21.5 9.5a.5.5 0 0 1-.01.918L1.7 21.96c-.457.191-.888-.328-.613-.74l5.152-8.167 15.764-1.05-15.755-1.051z"
});

var SvgSendEmailFilled = function SvgSendEmailFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgSendEmailFilled;